<script lang="ts">
  import WorkOrderSummaryTag from "../../../../../../../work-order-summary-tag"
  import type { PlanningPreviewRow } from "../../../../../../_shared/_logic/table-contract"
  const { row, disabled = false }: { row: PlanningPreviewRow; disabled?: boolean } = $props()
</script>
{#if row.workOrderSummaryTag}
  <div class="work-order-summary-cell"
    ><WorkOrderSummaryTag
      tag={row.workOrderSummaryTag}
      {disabled}
      fallbackLabel={row.orderTypeValue}
    /></div
  >
{:else}
  <span class="readonly-cell" title={row.orderTypeValue}>{row.orderTypeValue || "—"}</span>
{/if}
<style lang="less">
  .work-order-summary-cell {
    display: inline-flex;
    max-width: 18rem;
    min-width: 0;
  }

  .readonly-cell {
    display: inline-block;
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--text-invers-100);
    font-weight: 800;
  }
</style>
